import { render } from "./PaymentSlot.vue?vue&type=template&id=532a4b0d&scoped=true&ts=true"
import script from "./PaymentSlot.vue?vue&type=script&lang=ts"
export * from "./PaymentSlot.vue?vue&type=script&lang=ts"

import "./PaymentSlot.vue?vue&type=style&index=0&id=532a4b0d&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532a4b0d"]])

export default __exports__